
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="pt-24 sm:pt-28 md:pt-32 pb-12 sm:pb-16 md:pb-20 px-4 sm:px-6 bg-gradient-to-b from-sub/40 to-white">
      <div className="max-w-7xl mx-auto text-center">
        <div className="inline-block bg-white px-4 py-1 rounded-full mb-4 sm:mb-6 shadow-sm">
          <span className="text-primary text-xs font-medium tracking-wider uppercase">About</span>
        </div>
        <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-primary mb-4 sm:mb-6 px-4">
          おかやま鍼灸院について
        </h1>
        <nav className="flex items-center justify-center gap-2 text-xs sm:text-sm text-gray-600">
          <Link to="/" className="hover:text-primary transition-colors">トップ</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-primary font-medium">当院について</span>
        </nav>
      </div>
    </section>
  );
};

export default HeroSection;
